var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-image-slider"},[[_c('VueSlickCarousel',_vm._b({},'VueSlickCarousel',_vm.settings,false),[_vm._t("default")],2)]],2)}
var staticRenderFns = []

export { render, staticRenderFns }